import React, { Component } from 'react';
import {inject, observer} from "mobx-react";
import {api} from "../../../services";
import Spin from "antd/es/spin";
import K from "../../../constants";

@inject('connectionRequestsStore')
@observer
class SlimpayIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      success: false,
      iframeContent: null
    }
  }

  componentDidMount() {
    api('getSlimpayIframe', this.props.customerDetails.uuid)
      .then(result => {
        this.setState({
          loading: false,
          iframeContent: result.iframe
        }, () => {
          this.socket = new WebSocket(K.SLIMPAY_WS_URL);

          this.socket.addEventListener("open", event => {
            this.socket.send(JSON.stringify({type: "salutation", message: {id: this.props.customerDetails.zuora_account_id}}));
          });

          this.socket.addEventListener("message", event => {
            try {
              this.onNotification(event.data)
            } catch (e) {
              console.error("error parsing data!");
            }
          });
        })
      })
  }

  onNotification = async (data) => {
    if (this.props.connections) {
      await this.props.connectionRequestsStore.subscribeToProducts(this.props.customerDetails.uuid, this.props.connections);
    }
    this.props.onNext();
  };

  componentWillUnmount() {
    this.socket && this.socket.close();
  }

  render() {
    if (this.state.loading) {
      return <Spin />
    }

    return (
      <div
        className="CheckoutContainer"
      >
        <div
          className="SlimpayIframe"
          dangerouslySetInnerHTML={{ __html: this.state.iframeContent}}
          //height={600}
        />
      </div>
    )

  }
}

export default SlimpayIframe;



// WEBPACK FOOTER //
// ./src/components/App/PaymentPage/SlimpayIframe.js